// extracted by mini-css-extract-plugin
export var center = "_5n-2";
export var clickableRow = "_5n-5";
export var expandedRow = "_5n-7";
export var hoverable = "_5n-4";
export var left = "_5n-1";
export var right = "_5n-3";
export var row = "_5n-0";
export var selectedRow = "_5n-6";
export var summaryRow = "_5n-8";